var _defs, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause20240716235246(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0c1c3c;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 9px;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.29,
    y1: 12.25,
    x2: 20.29,
    y2: 94
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 56.71,
    y1: 12.25,
    x2: 56.71,
    y2: 94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause20240716235246);
export default __webpack_public_path__ + "static/media/PAUSE-20240716-235246.fdcc3196e77e1886bdd7f55b161c17fd.svg";
export { ForwardRef as ReactComponent };